import { GenericResponse } from "./generic-response";
import { Licences } from "./licences";
import { AuthMode } from "./auth-mode";
import { CollectionToCopy } from "./collection-to-copy";

export class GetPlatformInfosEnumsResponse extends GenericResponse<GetPlatformInfosEnumsResponse> {
  licences: Licences[] | null = null;
  authModes: AuthMode[] | null = null;
  collectionsToCopy: CollectionToCopy[] | null = null;

  constructor(init?: Partial<GetPlatformInfosEnumsResponse>) {
    super();
    Object.assign(this, init);
  }
}
